import './package-transport.scss';

import { Outlet } from "react-router-dom";

import { FilterPackageTransportProvider } from "./filter-package-transport/filter-package-transport.context";

export function PackageTransport() {
  return (
    <div id="ShellPackageTransport" className="package-transport">
       <FilterPackageTransportProvider>
        <Outlet />
      </FilterPackageTransportProvider>
    </div>
  );
}

export default PackageTransport;
